export const SDK_VERSION = '6.12.0';
